import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    CreditorConnectionModel,
    PayoutCreditFacilityModel,
} from '../types'

interface PayoutCreditFacilityState {
    loading: boolean
    facilityDetails: PayoutCreditFacilityModel | null
    createdFacilityId: string | null
    error: Error | string | null
}

const initialState: PayoutCreditFacilityState = {
    loading: false,
    facilityDetails: null,
    createdFacilityId: null,
    error: null
}

export const payoutCreditFacilitySlice = createSlice({
    name: 'payoutCreditFacility',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        payoutCreditFacilityDetailsFetched: (state, action: PayloadAction<PayoutCreditFacilityModel>) => {
            state.loading = false
            state.facilityDetails = action.payload
            state.error = null
        },
        payoutCreditFacilityDetailsFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityCreated: (state, action: PayloadAction<string>) => {
            state.loading = false
            state.createdFacilityId = action.payload
            state.error = null
        },
        payoutCreditFacilityCreationHandled: state => {
            state.createdFacilityId = null
        },
        payoutCreditFacilityCreateFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityUpdated: (state, action: PayloadAction<PayoutCreditFacilityModel>) => {
            state.loading = false
            state.facilityDetails = action.payload
            state.error = null
        },
        payoutCreditFacilityUpdateFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityBankAccountSet: (state, action: PayloadAction<PayoutCreditFacilityModel>) => {
            state.loading = false
            state.facilityDetails = action.payload
            state.error = null
        },
        payoutCreditFacilityBankAccountSetFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityCreditSpaceWarningSilenced: (state, action: PayloadAction<PayoutCreditFacilityModel>) => {
            state.loading = false
            state.facilityDetails = action.payload
            state.error = null
        },
        payoutCreditFacilityCreditSpaceWarningSilenceFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityCreditorAdded: (state, action: PayloadAction<CreditorConnectionModel>) => {
            state.loading = false
            state.facilityDetails = {
                ...state.facilityDetails as PayoutCreditFacilityModel,
                creditors: [action.payload, ...state.facilityDetails?.creditors ?? []]
              }
            state.error = null
        },
        payoutCreditFacilityCreditorAddFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        payoutCreditFacilityCreditorDeleted: (state, action: PayloadAction<string>) => {
            var index = state.facilityDetails?.creditors.findIndex((item) => {
                return item.id === action.payload
            })
            const creditors = [...state.facilityDetails?.creditors ?? []]
            creditors.splice(index ?? 0, 1)

            state.loading = false
            state.facilityDetails = {
                ...state.facilityDetails as PayoutCreditFacilityModel,
                creditors: creditors
              }
            state.error = null
        },
        payoutCreditFacilityCreditorDeleteFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        }
    }
})

export const {
    loading,
    payoutCreditFacilityDetailsFetched,
    payoutCreditFacilityDetailsFetchFailure,
    payoutCreditFacilityCreated,
    payoutCreditFacilityCreationHandled,
    payoutCreditFacilityCreateFailure,
    payoutCreditFacilityUpdated,
    payoutCreditFacilityUpdateFailure,
    payoutCreditFacilityBankAccountSet,
    payoutCreditFacilityBankAccountSetFailure,
    payoutCreditFacilityCreditSpaceWarningSilenced,
    payoutCreditFacilityCreditSpaceWarningSilenceFailure,
    payoutCreditFacilityCreditorAdded,
    payoutCreditFacilityCreditorAddFailure,
    payoutCreditFacilityCreditorDeleted,
    payoutCreditFacilityCreditorDeleteFailure
} = payoutCreditFacilitySlice.actions
export default payoutCreditFacilitySlice.reducer
